import React from 'react';
import { ContentfulShowcaseCard, ContentfulTheme } from '@jbhi-fi/apis/src/contentful/types';
import { AssetTransformer } from './AssetTransformer';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import type { ShowcaseCardProps } from '../../ShowcaseCard/ShowcaseCard';
import { ThemeTransformer } from './ThemeTransformer';

export abstract class ShowcaseCardTransformer {
  static toShowcaseCardProps = (entry: ContentfulShowcaseCard, theme: ContentfulTheme): ShowcaseCardProps => {
    const contentfulTheme = ThemeTransformer.toContentThemeVariables(theme);
    const image = entry?.fields?.image ? (
      <ContentfulImage {...AssetTransformer.toContentfulImageProps(entry?.fields?.image)} aspectRatio={1} />
    ) : undefined;
    const showcaseCardProps = {
      heading: entry?.fields?.heading || '',
      subText: entry?.fields?.subText,
      image,
      url: entry?.fields?.url,
      openInNewWindow: entry?.fields?.openInNewWindow,
      backgroundColor: contentfulTheme.palette?.background,
      textColor: contentfulTheme.palette?.text || '#FFFFFF',
    };
    return showcaseCardProps;
  };
}
